<mat-toolbar
  class=" pc-header"
  [ngClass]="{
    'header-blur': HeaderBlur,
    'bg-primary-500': true
  }"
  [style.background]="headerColoring ? 'var(--primary-500) !important': ''"
>
  <div class="header-wrapper">
    <app-nav-left [invertColor]="headerColoring"></app-nav-left>
    <app-nav-right (HeaderBlur)="this.HeaderBlur = !this.HeaderBlur" [invertColor]="headerColoring" ></app-nav-right>
  </div>
</mat-toolbar>
